import { api } from '../lib/api'

export type UserSubscription = {
  creator_id: number
  tier_id?: number | null
  tier_name?: string | null
  tier_rank?: number | null
  pending_tier_id?: number | null
  pending_tier_name?: string | null
  pending_tier_rank?: number | null
  status: 'active' | 'canceled' | 'paused' | 'past_due' | 'expired'
  started_at?: string
  current_period_start?: string
  current_period_end?: string | null
  renews?: boolean
  auto_renew?: boolean
  canceled_at?: string | null
  last_renewed_at?: string | null
  provider?: 'PIXE' | 'STRIPE'
}

export async function listMySubscriptions() {
  const { data } = await api.get<{ results: UserSubscription[] }>('/api/subscriptions/')
  return data
}

export async function subscribeToCreator(creatorId: number, opts?: { idempotencyKey?: string; tierId?: number | null }) {
  const headers: Record<string, string> = {}
  if (opts?.idempotencyKey) headers['Idempotency-Key'] = opts.idempotencyKey
  const { data } = await api.post<UserSubscription>(
    '/api/subscriptions/',
    { creator_id: creatorId, provider: 'PIXE', tier_id: opts?.tierId ?? null },
    { headers }
  )
  return data
}

export async function cancelSubscription(creatorId: number) {
  const { data } = await api.delete<{ ok: boolean; status: string }>(`/api/subscriptions/${creatorId}/`)
  return data
}

export async function renewSubscription(creatorId: number) {
  const { data } = await api.post<UserSubscription>(`/api/subscriptions/${creatorId}/renew/`, {})
  return data
}

export async function changeSubscriptionTier(creatorId: number, payload: { tier_id: number; change_type: 'upgrade' | 'downgrade' }) {
  const { data } = await api.post<UserSubscription>(`/api/subscriptions/${creatorId}/change-tier/`, payload)
  return data
}
